import React from 'react';
import { Button } from '@/components/common/Button';

export const PlansBilling: React.FC = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="text-center py-12">
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Plans & Billing
        </h3>
        <p className="text-gray-500 mb-6">
          Manage your subscription and billing information
        </p>
        <Button variant="primary">
          View Plans
        </Button>
      </div>
    </div>
  );
};